<template>
    <svg width="24" height="25" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 0C3.49334 0 0 3.30113 0 7.76C0 10.0923 0.955844 12.1077 2.51244 13.4997C2.64313 13.6167 2.722 13.7805 2.72734 13.9558L2.77091 15.3789C2.78481 15.8328 3.25369 16.1282 3.66906 15.9448L5.25694 15.2438C5.39153 15.1844 5.54238 15.1734 5.68422 15.2124C6.41391 15.4131 7.1905 15.52 7.99997 15.52C12.5066 15.52 16 12.2188 16 7.75997C16 3.30109 12.5066 0 8 0Z"
              fill="url(#paint0_radial_8_2945)" />
        <path fill-rule="evenodd" clip-rule="evenodd"
              d="M3.19604 10.0294L5.54604 6.3011C5.91986 5.70797 6.72032 5.56028 7.2812 5.98094L9.15026 7.38275C9.32176 7.51141 9.5577 7.51069 9.72848 7.3811L12.2528 5.46535C12.5897 5.20966 13.0295 5.61288 12.804 5.97069L10.454 9.69903C10.0802 10.2921 9.2797 10.4398 8.71885 10.0192L6.84973 8.61731C6.67826 8.48872 6.44229 8.48941 6.27154 8.619L3.74726 10.5348C3.41032 10.7904 2.97051 10.3872 3.19604 10.0294Z"
              fill="white" />
        <defs>
            <radialGradient id="paint0_radial_8_2945" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                            gradientTransform="translate(3.08125 15.8057) scale(17.425 17.425)">
                <stop stop-color="#0099FF" />
                <stop offset="0.6098" stop-color="#A033FF" />
                <stop offset="0.9348" stop-color="#FF5280" />
                <stop offset="1" stop-color="#FF7061" />
            </radialGradient>
        </defs>
    </svg>
</template>
<script>
export default {
    name: "MessengerIcon",
};
</script>
<style scoped></style>